export const fr = {
  scene: {
    loading: 'Chargement de l’arrière-plan…',
    recovering: 'Restauration de l’image…',
    unavailable: 'Impossible de charger l’arrière-plan',
    retryHint:
      'Nouvelle tentative en cours. Si le chargement ne se termine pas, rouvrez l’application.',
  },
  bootstrap: {
    unsupportedBrowser: {
      title: 'Ce navigateur n’est pas pris en charge',
      description: 'Les graphismes de l’application sont indisponibles avec la configuration actuelle de votre navigateur. Ouvrez Neiro Oracle dans un autre navigateur de la liste ci-dessous.',
      browsers: 'Navigateurs pris en charge',
      requirement: 'Utilisez une version à jour avec les graphismes WebGL disponibles. Les réglages du navigateur ou de l’appareil peuvent en limiter le fonctionnement.',
      safari: 'Safari · iPhone, iPad et Mac',
    },
    loadingSpace: 'Préparation de votre espace…',
    loadingOracle: 'Ouverture de l’Oracle…',
    startupError: 'Impossible de démarrer l’application',
    retry: 'Réessayer',
    staleTelegram:
      'Votre session Telegram a expiré. Fermez puis rouvrez la Mini App.',
    authTelegramError: 'Impossible de confirmer la connexion via Telegram',
    updateTelegramError:
      'Impossible de mettre à jour la Mini App. Fermez-la complètement puis rouvrez-la.',
    missingTelegramData:
      'Telegram n’a pas fourni les données de lancement. Fermez puis rouvrez la Mini App.',
  },
  back: 'Retour',
  close: 'Fermer',
  loading: 'Chargement…',
  routeReading: {
    loading: 'Ouverture de la lecture…',
    error: 'Lecture indisponible',
    errorHint:
      'Elle a peut-être été supprimée ou appartient à un autre profil.',
    retry: 'Réessayer',
  },
  save: 'Enregistrer',
  tomorrow: 'Demain',
  collapse: 'Réduire',
  app: {
    title: 'NEIRO ORACLE',
    subtitle: 'Système de divination v{{version}}',
    version: 'v{{version}}',
  },
  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: 'Comment fonctionne l’Oracle',
    introduction: 'Deux façons de consulter le Yi Jing selon vos besoins.',
    accessibilityLabel: 'Guide du signe du jour et des lectures',
    open: 'Comment utiliser l’Oracle',
    close: 'Fermer le guide',
    understood: 'Compris',
    daily: {
      title: 'Signe du jour',
      body: 'Aucune question n’est nécessaire. Le signe propose un thème et un repère pratique pour la journée.',
    },
    reading: {
      title: 'Lecture',
      body: 'Formulez une question précise et gardez-la à l’esprit en lançant les pièces. La lecture présente la situation actuelle, ses changements et une direction possible.',
    },
    journal: {
      title: 'Journal',
      body: 'Les signes du jour et les lectures partagent le même historique. Vous pouvez noter une décision après une lecture.',
    },
    example: {
      title: 'Une question utile',
      body: '« Que devrais-je prendre en compte avant de parler à mon équipe ? »',
    },
  },
  dailyDetails: {
    title: 'Détails',
    loading: 'Chargement du signe…',
    loadError: 'Le signe n’a pas pu être chargé dans la langue choisie.',
    retry: 'Réessayer',
    fullText: 'Thème du jour',
    situationEssence: 'Question à examiner',
    innerTension: 'À garder à l’esprit',
    action: 'Que faire aujourd’hui',
    askAbout: 'Poser une question à ce sujet',
    introduction:
      'Le signe du jour ne nécessite aucune question. Il propose un thème et un repère pratique pour la journée.',
  },
  classicalText: {
    title: 'TEXTE CLASSIQUE',
    future: 'CLASSIQUE · SIGNE FUTUR',
    judgment: 'JUGEMENT DE L’HEXAGRAMME',
    lines: 'TEXTES DES TRAITS',
    parallelLines: 'TRAITS DE L’HEXAGRAMME',
    line: 'Ligne {{number}}',
    lineStatement: 'ÉNONCÉ CLASSIQUE',
    sourceLabel: 'Yi Jing',
    rulingLine: 'TRAIT MAÎTRE',
    specialLine: 'Énoncé particulier',
  },
  home: {
    title: 'NEIRO ORACLE',
    subtitle: 'Système de divination v{{version}}',
    statusText: '> Tous les systèmes fonctionnent',
    daily: {
      title: 'Signe du jour',
      caption: 'Sans question · un thème et un repère pour la journée',
      actionTitle: 'Action du jour',
      askNow: 'Commencer une lecture',
      moreDetails: 'Lire la suite',
      hideDetails: 'Masquer les détails',
      detailsTitle: 'Description complète',
      lastResult: 'Dernier résultat',
      noLastResult: 'Aucune',
      emptyState: 'Aucune lecture. Commencez une lecture →',
      empty: {
        subtitle: 'Touchez pour recevoir le signe du jour',
        hint: 'Rituel en un geste',
        button: 'Recevoir le signe',
      },
      loading: {
        searching: 'Recherche de l’hexagramme…',
        revealing: 'Révélation des six traits…',
      },
      pinnedToday: 'Fixé pour aujourd’hui',
      newSign: 'Nouveau signe',
      resetReasons: {
        title: 'Motif du renouvellement',
        sleep: 'Réveil après le sommeil',
        situationChanged: 'La situation a changé',
        other: 'Autre',
      },
      resetConfirm: {
        title: 'Renouveler le signe ?',
        message:
          'Renouveler le signe pour un nouveau cycle d’éveil ? Le signe actuel restera dans le journal.',
        confirm: 'Renouveler',
        cancel: 'Annuler',
      },
      nextUpdate: {
        prefix: 'Prochain nouveau signe —',
        afterSleep: 'après le prochain sommeil',
        tomorrow: 'demain à 07 h 00',
        or: 'ou',
        available: 'disponible maintenant',
      },
      updated: 'Signe renouvelé — nouveau cycle d’éveil',
      limitReached: 'Limite de renouvellements atteinte pour aujourd’hui',
      disclaimer:
        'Pour la réflexion personnelle et le divertissement. Ne constitue pas un conseil médical ou financier.',
    },
    question: {
      title: 'Vous avez une question précise ?',
      subtitle:
        'Une lecture explore la situation, ses changements et une direction possible',
      askNow: 'Commencer une lecture',
      hint: 'Sans thème. Affiche l’hexagramme futur, les traits actuels et les traits mutants',
    },
    buttons: {
      iching: 'ORACLE YI JING',
      designSystem: 'SYSTÈME DE DESIGN',
      simpleTest: 'TEST SIMPLE',
      hexagramTest: 'TEST DES HEXAGRAMMES',
    },
  },
  iching: {
    title: 'ORACLE YI JING',
    subtitle: 'MOBILE v{{version}}',
    throwCoins: 'Lancer les pièces',
    castingHexagram: 'Formation de l’hexagramme…',
    generationError:
      'Le signe ne s’est pas formé. Vérifiez votre connexion et recommencez le rituel.',
    retry: 'Réessayer',
    castingWisdom: {
      '1': 'Un voyage de mille li commence par un seul pas',
      '2': 'Ne craignez pas d’avancer lentement ; craignez de rester immobile',
      '3': 'Le souple surmonte le dur, le calme surmonte l’agitation',
      '4': 'Le changement est la seule constante sous le ciel',
      '5': 'Le sage s’adapte comme l’eau à la forme du vase',
      '6': 'Quand le signe se forme, la réponse est déjà en vous',
    },
    instruction: 'Touchez pour former votre hexagramme et recevoir un conseil',
    linkActive: 'CONNEXION ACTIVE',
    backButton: '← ACCUEIL',
    newDivination: 'NOUVELLE DIVINATION',
    sections: {
      hexagrams: 'HEXAGRAMMES',
      interpretation: 'INTERPRÉTATION',
      aiInsights: 'ÉCLAIRAGES IA',
      general: 'INTERPRÉTATION GÉNÉRALE',
      love: 'AMOUR ET RELATIONS',
      work: 'TRAVAIL ET CARRIÈRE',
      health: 'SANTÉ ET BIEN-ÊTRE',
      travel: 'VOYAGES ET PARCOURS',
      changingLines: 'TRAITS MUTANTS',
      futureHexagram: 'ÉTAT POSSIBLE',
      structuralFocus: 'CE QUI SOUTIENT LA SITUATION',
    },
    hexagram: {
      current: 'ACTUEL',
      future: 'POSSIBLE',
      present: 'SITUATION ACTUELLE',
      outcome: 'DIRECTION POSSIBLE',
      changing: 'TRAITS MUTANTS',
      structural: 'CE QUI LA MAINTIENT',
    },
    insights: {
      analyzing: 'Élaboration de la lecture…',
      transformation:
        '« {{current}} » peut évoluer vers « {{future}} ». Traits mutants : {{changes}}.',
      stable:
        'Aucun trait ne change. La situation conserve sa direction actuelle.',
    },
    changingLines: 'Traits mutants',
    changingLinesDescription:
      'Ces traits indiquent où la situation peut changer.',
    governingLineHint: 'La couronne indique une ligne maîtresse de cet hexagramme.',
    changingLinesTitle: 'Traits mutants ({{count}})',
    structuralFocusTitle: 'Ce qui maintient la situation',
    structuralFocusDescription:
      'Lorsqu’aucun trait ne change, ces positions montrent ce qui maintient la situation actuelle.',
    lineNumber: 'Ligne {{number}}',
    changingLinesNote:
      'Lisez ces traits attentivement : ils indiquent où le changement se produit.',
  },
  ask: {
    throw: {
      prepare: 'Formulez brièvement votre question et gardez-la à l’esprit.',
      tips: {
        heart: 'Dites ce qui compte pour vous',
        specific: 'Décrivez la situation précise',
        openEnded: 'Demandez ce que vous devriez prendre en compte',
      },
      example:
        'Par exemple : « Que devrais-je prendre en compte avant de décider ? »',
      guide: {
        title: 'Préparation',
        bestTime:
          'Posez votre question lorsque vous êtes prêt à examiner la réponse calmement',
        todayGood:
          'Gardez du temps pour vérifier les faits avant une décision importante',
      },
    },
    result: {
      sections: {
        future: 'Direction possible',
        present: 'Ce qui se passe maintenant',
        changes: 'Point central de la lecture',
        structuralFocus: 'Ce qui la maintient',
        advice: 'Comment agir',
      },
      accessibility: {
        advice: 'Comment agir. Conseil',
      },
      content: {
        check: 'Question à examiner',
        caution: 'À garder à l’esprit',
        primaryLine: 'Point principal',
        secondaryLine: 'Détail complémentaire',
        relatingHint:
          'L’hexagramme résultant propose un autre thème à mettre en regard de la situation.',
        visibleStructure: 'Comment la situation prend forme',
        resultStructure: 'Comment la situation peut évoluer',
        hiddenDynamic: 'Ce qui se passe en profondeur',
        hiddenCondition: 'Ce qui peut influencer l’issue',
        corePattern: 'Ce qu’il faut observer',
        coreTension: 'Où se situe la difficulté',
        question: 'Votre question',
        questionContext: 'Dans le contexte de la question',
        currentAction: 'Que faire maintenant',
        entryCondition: 'Comment s’en rapprocher',
        progressMarker: 'Comment reconnaître les progrès',
      },
      changeDepth: {
        stable:
          'Aucun trait ne change. La section suivante montre ce qui maintient la situation actuelle.',
        boundary:
          'Le changement touche la façon dont la situation commence ou se termine.',
        internal:
          'Le changement touche ce qui se passe à l’intérieur de la situation.',
        systemic:
          'Le changement atteint les fondements de la situation et peut en modifier le cours.',
      },
      buttons: {
        decide: 'Prendre une décision',
      },
      more: 'Lire la suite',
      skeleton: {
        loading: 'Chargement…',
      },
    },
    acceptDecision: {
      back: 'Retour',
      title: 'Prendre une décision',
      subtitle:
        'Ajoutez du contexte pour vous rappeler plus tard de quoi il s’agissait.',
      reading: 'Fondement de la décision',
      questionLabel: 'Sur quoi porte cette décision ?',
      questionPlaceholder: 'Décrivez brièvement la situation ou la question…',
      questionHint: 'Facultatif. Ce contexte sera enregistré dans le journal.',
      confirm: 'Accepter et enregistrer',
      saving: 'Enregistrement…',
      cancel: 'Annuler',
      errorTitle: 'Décision non enregistrée',
      errorMessage: 'Veuillez réessayer.',
    },
  },
  themes: {
    title: 'THÈME',
    dark: 'SOMBRE',
    light: 'CLAIR',
    autumn: 'AUTOMNE',
    active: 'ACTIF',
    dark_description: 'Surfaces sombres aux accents discrets',
    light_description: 'Thème clair, épuré et moderne',
    autumn_description: 'Tons chauds et naturels inspirés de l’automne',
  },
  ui: {
    screenTitle: 'TITRE DE L’ÉCRAN',
    info: 'INFOS',
    language: 'LANGUE',
    interfaceSettings: 'Langue et thème',
    loadingStates: {
      loading: 'Chargement…',
      processing: 'TRAITEMENT…',
      connecting: 'CONNEXION…',
      deleting: 'SUPPRESSION…',
    },
  },
  tabs: {
    home: 'Accueil',
    journal: 'Journal',
    hexagrams: 'Hexagrammes',
    profile: 'Profil',
  },
  desktop: {
    oracle: 'Oracle',
    brandSubtitle: 'Le Yi Jing pour décider',
    appearance: 'Apparence',
    theme: 'Thème de l’interface',
  },
  hexagrams: {
    title: 'Hexagrammes',
    subtitle: 'Les 64 signes du Yi Jing — choisissez l’ordre qui vous convient',
    hint: 'Choisissez un signe pour ouvrir son interprétation',
    loading: 'Chargement du catalogue des hexagrammes…',
    error: 'Le catalogue des hexagrammes n’a pas pu être chargé.',
    retry: 'Réessayer',
    order: {
      title: 'Ordre',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Fu Xi',
      'fu-xi': 'Fu Xi',
      mawangdui: 'Mawangdui',
    },
    matrix: {
      accessibilityLabel: 'Matrice des 64 hexagrammes. Ordre : {{order}}',
      cellAccessibilityLabel: 'Hexagramme {{number}}. {{name}}',
    },
    modal: {
      accessibilityLabel: 'Hexagramme {{number}}. {{name}}',
      number: 'Hexagramme {{number}}',
      close: 'Fermer les détails de l’hexagramme',
      modernTitle: 'Interprétation moderne',
      pattern: 'Ce qui se passe',
      tension: 'Où se situe la difficulté',
      structureTitle: 'Structure de la situation',
      visibleStructure: 'Comment la situation prend forme',
      hiddenDynamic: 'Ce qui se passe en profondeur',
      rolesTitle: 'Rôle de l’hexagramme',
      initialRole: 'Quand le signe décrit la situation actuelle',
      resultingRole: 'Quand le signe représente un état possible',
      roleSummary: 'Sens du rôle',
      action: 'Comment agir',
      entry: 'Comment entrer dans cet état',
      marker: 'Signe de progrès',
      linesTitle: 'Six traits',
      spheresTitle: 'Action pour votre thème',
      spheres: {
        general: 'Situation ou choix',
        newjob: 'Nouveau travail',
        work: 'Travail actuel',
        love: 'Relations',
        project: 'Projet',
      },
      dailyTitle: 'Repère du jour',
      dailyFocus: 'Thème de la journée',
      dailyAction: 'Étape concrète',
    },
  },
  journal: {
    actionsFor: 'Actions pour « {{title}} »',
    entryActions: 'Actions sur l’entrée',
    deleteConfirm: 'Supprimer l’entrée ?',
    deleteEntry: 'Supprimer',
    cancelDelete: 'Annuler',
    deleting: 'Suppression…',
    deleteDailyHint:
      'Ce signe sera supprimé. S’il est actuel, le dernier signe restant pour cette date le remplacera. Le premier signe du jour sera conservé.',
    deleteReadingHint:
      'Cette lecture et la décision associée seront définitivement supprimées.',
    deleteError: 'Impossible de confirmer la suppression. Veuillez réessayer.',
    selectEntry: 'Sélectionnez une entrée du journal',
    entryNotFound:
      'Entrée introuvable. Sélectionnez-en une autre dans la liste.',
    title: 'Journal',
    filters: {
      all: 'Tout',
      decisions: 'Lectures',
      daily: 'Signe du jour',
    },
    searchPlaceholder: 'Rechercher par titre et note',
    empty: 'Vos lectures apparaîtront ici',
    emptyHint:
      'Votre première lecture apparaît après « Commencer une lecture »',
    emptyAll: 'Les entrées de votre journal apparaîtront ici',
    emptyAllHint: 'Lectures et signes du jour restent dans un même historique',
    emptyDecisions: 'Vos lectures apparaîtront ici',
    emptyDecisionsHint:
      'Votre première lecture apparaît après « Commencer une lecture »',
    emptyDaily: 'Vos signes du jour apparaîtront ici',
    emptyDailyHint: 'Recevez votre premier signe depuis l’écran Oracle',
    error: 'Le journal n’a pas pu être chargé',
    errorHint: 'Vérifiez votre connexion et réessayez',
    retry: 'Réessayer',
    labels: {
      decision: 'Lecture',
      accepted: 'Lecture · décision enregistrée',
      daily: 'Signe du jour',
      question: 'Question',
    },
  },
  profile: {
    title: 'Profil',
    account: {
      title: 'Compte',
      loginTelegram: 'Continuer avec Telegram',
      loginHint:
        'L’historique du compte sera accessible sur vos appareils ; les entrées locales resteront sur cet appareil',
      loginUnavailable:
        'La connexion sera disponible après l’activation de Telegram Login',
      synchronized:
        'Les données du compte sont synchronisées entre les appareils',
      logout: 'Se déconnecter',
      loginErrorTitle: 'Échec de la connexion',
      loginError: 'Telegram n’a pas confirmé la connexion. Veuillez réessayer.',
      logoutErrorTitle: 'Échec de la déconnexion',
      logoutError: 'Vérifiez votre connexion et réessayez.',
    },
    subscription: {
      title: 'Abonnement',
      active: 'Actif',
      expired: 'Expiré',
      free: 'Mode gratuit',
      activeUntil: 'Actif jusqu’au {{date}}',
      manage: 'Gérer l’abonnement',
      connect: 'Obtenir Neiro+',
      restore: 'Restaurer les achats',
      hint: 'Accès aux interprétations approfondies, aux comparaisons et aux conseils personnels.',
      restored: 'Achats restaurés',
      restoreError: 'Impossible de restaurer les achats',
      purchaseError: 'Impossible de lancer l’abonnement dans l’App Store',
      loading: 'Vérification du statut…',
      benefits: {
        extendedInterpretations: 'Interprétations approfondies',
        personalAdvice: 'Conseils personnels',
        comparisons: 'Comparer les options',
      },
      whatsIncluded: 'Qu’est-ce qui est inclus ?',
    },
    notifications: {
      title: 'Notifications',
      morning: 'Matin',
      morningHint: 'Choisissez quand et où recevoir votre signe du matin',
      morningEnabledDestinationsHint:
        'Le signe du jour est renouvelé à {{time}} · {{destinations}}',
      morningDisabledDestinationsHint:
        'Le signe du jour est renouvelé à {{time}} ; les notifications sont désactivées',
      destinations: {
        title: 'Envoyer les rappels vers',
        local: 'Ce Mac',
        telegram: 'Telegram',
      },
      timeHint: 'Heure du matin',
      invalidTime: 'Saisissez l’heure au format HH:MM, par exemple 09:00',
      timePicker: {
        title: 'Quand commence votre matinée ?',
        descriptionEnabled:
          'À cette heure, votre signe du jour est renouvelé et le bot Telegram envoie un rappel.',
        descriptionEnabledLocal:
          'À cette heure, votre signe du jour est renouvelé et macOS affiche un rappel.',
        descriptionEnabledMultiple:
          'À cette heure, votre signe du jour est renouvelé et les canaux choisis envoient un rappel.',
        descriptionDisabled:
          'À cette heure, votre signe du jour est renouvelé. Les notifications resteront désactivées.',
        descriptionChannelUnavailable:
          'À cette heure, votre signe du jour est renouvelé. Les rappels commenceront lorsque le canal Telegram sera disponible.',
        descriptionChannelUnavailableLocal:
          'À cette heure, votre signe du jour est renouvelé. macOS demandera l’autorisation d’envoyer des notifications.',
        quickChoice: 'Choix rapide',
        setPreset: 'Définir {{time}}',
        hours: 'Heures',
        minutes: 'Minutes',
        decreaseHours: 'Diminuer d’une heure',
        increaseHours: 'Augmenter d’une heure',
        decreaseMinutes: 'Diminuer de cinq minutes',
        increaseMinutes: 'Augmenter de cinq minutes',
        directEntryHint: 'Vous pouvez saisir une valeur précise au clavier',
        invalidHours: 'Saisissez une heure de 00 à 23',
        invalidMinutes: 'Saisissez les minutes de 00 à 59',
      },
      loadError: 'Impossible de charger le réglage du matin',
      saveError: 'Impossible d’enregistrer le réglage du matin',
      retry: 'Réessayer',
      testSent: 'Message de test envoyé dans Telegram',
      testSentLocal: 'Une notification de test apparaîtra dans deux secondes',
      testSentMultiple: 'Rappels de test envoyés aux canaux choisis',
      testError: 'Impossible d’envoyer le message de test',
      channel: {
        active: 'Le bot Telegram est prêt',
        unverified:
          'Ouvrez le bot Telegram et confirmez la réception des messages',
        blocked: 'Le bot Telegram est bloqué. Débloquez-le dans Telegram',
        disconnected: 'La connexion au bot Telegram a été perdue',
        not_connected: 'Le bot Telegram n’est pas encore connecté',
      },
      localChannel: {
        active: 'Les notifications macOS sont autorisées',
        unverified:
          'L’autorisation des notifications macOS n’est pas confirmée',
        blocked: 'Autorisez les notifications dans les réglages macOS',
        disconnected: 'Les notifications macOS sont actuellement indisponibles',
        not_connected:
          'L’autorisation sera demandée à l’activation des rappels',
      },
      testNotification: 'Envoyer un test',
    },
    preferences: {
      title: 'Préférences',
      haptics: 'Retour haptique',
      hapticsHint: 'Légère vibration au lancer et à l’enregistrement',
    },
    classicalText: {
      title: 'Textes des hexagrammes',
      hint: 'Choisissez la lecture moderne, le texte traditionnel du Zhouyi ou les deux',
      modern: 'Modernes',
      classical: 'Classiques',
      parallel: 'Les deux',
    },
    language: {
      interface: 'Langue de l’interface',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: 'Données et confidentialité',
      exportJournal: 'Exporter le journal',
      exportPeriod: 'Période',
      allData: 'Toutes les données',
      last30Days: '30 derniers jours',
      export: 'Exporter',
      exportError: 'Échec de l’exportation',
      deleteAccount: 'Supprimer les données personnelles et le compte',
      deleteAccountHint:
        'Les données personnelles, l’historique, les préférences et le compte seront supprimés de l’application',
      deleteAccountConfirm:
        'Les données du profil, le journal, les préférences et le compte seront supprimés. La prochaine connexion créera un nouveau compte. Seuls des justificatifs techniques sans contenu subsisteront : ceux de Telegram pendant 7 jours pour éviter le retraitement des requêtes, et la confirmation de suppression pendant 30 jours. Ils seront ensuite automatiquement supprimés.',
      deleteAccountError:
        'Impossible de supprimer les données personnelles et le compte. Vérifiez la connexion et réessayez.',
      deleteLocalData: 'Supprimer toutes les données personnelles',
      deleteLocalDataHint:
        'L’historique et les préférences enregistrés par cette application sur l’appareil seront supprimés',
      deleteLocalDataConfirm:
        'Toutes les données enregistrées par cette application sur l’appareil seront supprimées. Un écran initial vierge s’ouvrira ensuite.',
      deleteLocalDataError:
        'Impossible de supprimer les données de l’application. Veuillez réessayer.',
      cancel: 'Annuler',
      deleteAccountAction: 'Supprimer le compte',
      deleteLocalDataAction: 'Supprimer les données',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d’utilisation',
      disclaimer:
        'Pour la réflexion personnelle et le divertissement. Ne constitue pas un conseil médical ou financier.',
    },
    support: {
      title: 'Assistance',
      guide: 'Comment fonctionne l’Oracle',
      guideHint: 'Signe du jour, lectures et journal',
      contact: 'Contacter l’assistance',
      rate: 'Évaluer l’application',
      rateNow: 'Évaluer maintenant',
      version: 'Version {{version}}',
      devTools: 'Outils de développement',
      devToolsDesc:
        'Configuration distante, tests push, données simulées (espace réservé)',
    },
    about: {
      title: 'À propos',
      version: 'Version {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: 'Décider maintenant',
  },
};
